import { memo } from 'react'
import { getCodeToPaste } from 'utils'

const hasOnlyNumbers = (val) => /^[0-9]*$/.test(val)
const nonNumericalChars = ['e', 'E', '+', '-', '.', ',']

const statusClasses = {
  waiting: 'border-gray-500',
  error: 'border-red-900',
  success: 'border-green-800'
}

const SingleInput = ({
  classNames,
  name,
  type,
  OTPInput,
  disabled,
  setOTPInput,
  autoFocus = false,
  status = 'waiting'
}) => {
  const handleOnFocus = (e) => {
    e.target.select()
  }

  const handleChange = (index, e) => {
    // sino es un numero retorno false
    const val = e.target.value

    if (
      Number.isNaN(val) ||
      !hasOnlyNumbers(val) ||
      nonNumericalChars.includes(val) ||
      val.length > 1
    )
      return

    if (!val) e.preventDefault()

    // mapeo y actualizo el index
    setOTPInput([...OTPInput.map((d, idx) => (idx === index ? val : d))])

    if (e.currentTarget.nextSibling) {
      e.currentTarget.nextSibling?.focus()
    }
  }

  // useEffect(() => {
  //   let auxDisabled = false
  //   OTPInput.forEach((dataOTP) => {
  //     if (dataOTP === '') {
  //       auxDisabled = true
  //     }
  //   })
  // }, [OTPInput])

  const handleKeydown = (e, index) => {
    const pressedKey = e.key

    if (!hasOnlyNumbers(e.key) || nonNumericalChars.includes(pressedKey))
      e.preventDefault()

    e.persist()

    if (pressedKey === 'ArrowLeft' && e.currentTarget.previousSibling) {
      e.currentTarget.previousSibling?.focus()
    }

    if (pressedKey === 'ArrowRight' && e.currentTarget.nextSibling) {
      e.currentTarget.nextSibling?.focus()
    }

    if (pressedKey === 'Backspace') {
      e.preventDefault()
      const copyOTP = [...OTPInput]
      copyOTP[index] = ''
      setOTPInput([...copyOTP])
      e.currentTarget.previousSibling?.focus()
    }
  }

  return (
    <div className={classNames}>
      {OTPInput.map((data, index) => (
        <input
          key={index}
          value={data}
          className={`w-12 h-12 text-center rounded-lg bg-white mb-6 ${
            statusClasses[status]
          } border focus:border-0 focus:border-transparent focus:outline-none focus-visible:outline-none focus:ring-purple-900 ${
            disabled && '!bg-gray-300 border-gray-500 text-gray-900'
          }`}
          type={type}
          name={name}
          autoComplete='one-time-code'
          maxLength={1}
          onChange={(e) => handleChange(index, e)}
          onFocus={(e) => handleOnFocus(e)}
          onKeyDown={(e) => {
            handleKeydown(e, index)
          }}
          disabled={disabled}
          onPaste={(event) => {
            event.preventDefault()
            navigator.clipboard.readText().then((text) => {
              setOTPInput(getCodeToPaste(text))
            })
          }}
        />
      ))}
    </div>
  )
}

const OTPInput = memo(SingleInput)
export default OTPInput
